import { render, staticRenderFns } from "./AssessmentAnswerDialog.vue?vue&type=template&id=4cb4e2c2&scoped=true&"
import script from "./AssessmentAnswerDialog.vue?vue&type=script&lang=js&"
export * from "./AssessmentAnswerDialog.vue?vue&type=script&lang=js&"
import style0 from "./AssessmentAnswerDialog.vue?vue&type=style&index=0&id=4cb4e2c2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb4e2c2",
  null
  
)

export default component.exports